export const environment = {
	production: true,
	baseUrl: 'https://cloudapi.vitralogy.net/api',
	webViewer: {
		licenceKey: "Vitralogy LLC:OEM:Virtual Binder::B+:AMS(20240410):EA570E131FB79AD0D33352184F516F2F2292EC2BBB221909AD3470F054AA31F5C7",
		version: "10.7.3"
	},	
	auth: {
		domain: 'vitralogy.auth0.com',
		clientId: 'r6A3X35QWF852VC148vGu2ZIXrflinis'
	},
	platforms: {
		vendor: 'https://vendor.vitralogy.net',
		customer: 'https://customer.vitralogy.net'
	},
	apis: {
		commonApi: 'https://commonapi.vitralogy.net'
	}
};
